import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DTypeForm } from '@grupo-constant/next-dtype/form';
import { DType, DTypeComponent } from '@grupo-constant/next-dtype/types';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { cloneDeep } from 'lodash-es';
import { DialogsService } from '../dialogs.service';

import { MatIconModule } from '@angular/material/icon';
import { DtypeComponentListComponent } from '../../core/dtype/dtype-component-list/dtype-component-list.component';
import { DTypeService } from '../../core/dtype/dtype.service';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';
import { NextTaskTypeGoal } from '../../core/task-type/task-type.types';
import { FuseConfirmationDialogComponent } from '../../../@fuse/services/confirmation/dialog/dialog.component';

@Component({
    selector: 'app-upload-excel-dialog',
    templateUrl: './upload-excel-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, MatIconModule, DtypeComponentListComponent]
})
export class UploadExcelDialogComponent implements OnInit {

    dTypeForm: DTypeForm;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            dType: DType;
            excelType: string;
        },
        public dialogRef: MatDialogRef<UploadExcelDialogComponent>,
        private dialogsService: DialogsService,
        private dTypeService: DTypeService,
        private _fuseConfirmationService: FuseConfirmationService,
        private transloco: TranslocoService
    ) { }

    ngOnInit() {
        this.dTypeForm = this.dTypeService.getDtypeFormFromDtype(
            this.data.dType,
            {
                readonly: false,
                isUpdate: false
            }
        );
    }

    save() {
        const excelToUpload = this.dTypeForm.control;
        excelToUpload.markAllAsTouched();
        if (excelToUpload.valid) {
            const confirmDialog = this.openConfirmDialog(this.transloco.translate('uploadExcelConfirm'));
            confirmDialog.afterClosed().subscribe((confirm) => {
                if (confirm === 'confirmed') {
                    this.closeDialog(excelToUpload.getRawValue());
                }
            });
        } else {
            this.dialogsService.openErrorDialog({
                message: this.transloco.translate('errorsInForm')
            });
        }
    }

    closeDialog(result?: NextTaskTypeGoal): void {
        this.dialogRef.close(result);
    }

    private openConfirmDialog(message: string): MatDialogRef<FuseConfirmationDialogComponent, any> {
        return this._fuseConfirmationService.open({
            title: this.transloco.translate('warning'),
            message: message,
            actions: {
                confirm: {
                    label: this.transloco.translate('confirm')
                },
                cancel: {
                    label: this.transloco.translate('cancel')
                }
            }
        });
    }

}
